import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeDriver } from '../../redux/actions/drivers';

interface Props {
  match: any;
  handleRemoveDriver: Function;
}

const Route = ({ match, handleRemoveDriver }: Props) => (
  <RouteWrapper
    title="Remove Driver"
    requireAuth
    requirePermission="MANAGE_DRIVERS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Driver?</Title>
      <Subtitle>
        Once this driver is removed, you will not be able to reference them
        anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveDriver(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Driver
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/drivers/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveDriver: (id) => {
    dispatch(removeDriver(id)).then((response) => {
      if (!response.error) {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      } else {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
